import React, { useEffect, useState } from 'react';
import {
  Col,
  Form,
  Input,
  Row,
  Space,
  Typography,
  Select,
  Button,
  Checkbox,
  notification,
  Popconfirm,
} from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { RoleOptionsValues } from '../../../helpers/constants';

const { Title } = Typography;
const { TextArea } = Input;

export const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

export const roleOptions = [
  {
    value: RoleOptionsValues.LEASING_ADMIN,
    label: RoleOptionsValues.LEASING_ADMIN,
  },
  {
    value: RoleOptionsValues.LEASING_KORISNIK,
    label: RoleOptionsValues.LEASING_KORISNIK,
  },
  {
    value: RoleOptionsValues.DOBAVLJAC_ADMIN,
    label: RoleOptionsValues.DOBAVLJAC_ADMIN,
  },
  {
    value: RoleOptionsValues.DOBAVLJAC_KORISNIK,
    label: RoleOptionsValues.DOBAVLJAC_KORISNIK,
  },
];

const RegisterEditForm = ({ isAddUser, userState, actions }) => {
  const [form] = Form.useForm();
  const [showProvizija, setShowProvizija] = useState(
    !isAddUser
      ? userState?.currentUser?.role === 'Dobavljač korisnik'
        ? true
        : false
      : false
  );
  const [isBlocked, setIsBlocked] = useState(
    !isAddUser ? userState.currentUser.isBlocked : false
  );

  useEffect(() => {
    actions.getSuppliers();
  }, []);

  useEffect(() => {
    if (isAddUser && userState.resetRegisterFields) {
      form.resetFields();
    }
  }, [userState.resetRegisterFields]);

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, msg) => {
    api[type]({
      message: msg,
      style: {
        paddingRight: 40,
      },
    });
  };

  const onChangeDobavljac = value => {};

  const handleChangeRola = value => {
    if (value === RoleOptionsValues.DOBAVLJAC_KORISNIK) {
      setShowProvizija(true);
    } else {
      setShowProvizija(false);
    }
  };

  const onSearch = value => {};

  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  const onFinishAddUser = values => {
    const userData = {
      firstName: values.ime,
      lastName: values.prezime,
      userName: values.korisnik,
      email: values.email,
      password: values.lozinka,
      phoneNumber: values.telefon,
      role: values.rola,
      supplierId: values.dobavljač,
      hidebuttonProvision: values.provizija ? values.provizija : false,
      notification: values.notifikacija,
      annotation: values.napomena ? values.napomena : null,
    };

    actions.registerUser(userData);
  };

  const onFinishEditUser = values => {
    const userData = {
      firstName: values.ime,
      lastName: values.prezime,
      userName: values.korisnik,
      email: values.email,
      phoneNumber: values.telefon,
      role: values.rola,
      supplierId: values.dobavljač,
      hidebuttonProvision: values.provizija ? values.provizija : false,
      notification: values.notifikacija,
      annotation: values.napomena ? values.napomena : null,
      isBlocked,
    };

    actions.updateUserById(userData, userState.currentUser.id);
  };

  return (
    <Space direction="vertical" className="p-8 w-full">
      {contextHolder}
      <Title className="text-xl font-bold text-dark-blue ">
        {`${isAddUser ? 'REGISTRACIJA NOVOG KORISNIKA' : 'UREDI KORISNIKA'} `}
      </Title>
      <Form
        initialValues={{
          remember: true,
        }}
        {...layout}
        form={form}
        name="basic"
        onFinish={isAddUser ? onFinishAddUser : onFinishEditUser}
      >
        <Row>
          <Col span={12}>
            <Form.Item
              initialValue={!isAddUser ? userState.currentUser.userName : ''}
              colon={false}
              labelAlign="right"
              label="Korisničko ime"
              name="korisnik"
              rules={[
                {
                  required: true,
                  message: 'Unesite korisničko ime!',
                },
              ]}
            >
              <Input placeholder="Unesite korisničko ime" />
            </Form.Item>

            <Form.Item
              initialValue={!isAddUser ? userState.currentUser.email : ''}
              colon={false}
              labelAlign="right"
              label="email"
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Unesite email korisnika!',
                },
                { type: 'email' },
              ]}
            >
              <Input type="email" placeholder="Unesite email korisnika" />
            </Form.Item>

            {isAddUser && (
              <Form.Item
                // initialValue={!isAddUser ? userState.currentUser.password : ""}
                colon={false}
                labelAlign="right"
                label="Lozinka"
                name="lozinka"
                rules={[
                  {
                    required: true,
                    message: 'Unesite lozinku za korisnika!',
                  },
                  {
                    min: 8,
                    message: 'Lozinka mora imati najmanje 8 karaktera.',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.resolve();
                      }

                      const groups = [
                        /[A-Z]/.test(value),
                        /[a-z]/.test(value),
                        /\d/.test(value),
                        /[^A-Za-z0-9]/.test(value),
                      ];

                      const validGroups = groups.filter(Boolean).length;

                      if (validGroups >= 3) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        new Error(
                          'Lozinka mora imati karaktere iz najmanje 3 od 4 grupe: velika slova (A-Z), mala slova (a-z), brojevi (0-9), specijalni znakovi.'
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input
                  type="password"
                  placeholder="Unesite lozinku za korisnika"
                />
              </Form.Item>
            )}

            <Form.Item
              initialValue={!isAddUser ? userState.currentUser.firstName : ''}
              colon={false}
              labelAlign="right"
              label="Ime"
              name="ime"
              rules={[
                {
                  required: true,
                  message: 'Unesite ime korisnika!',
                },
              ]}
            >
              <Input placeholder="Unesite ime korisnika" />
            </Form.Item>

            <Form.Item
              initialValue={!isAddUser ? userState.currentUser.lastName : ''}
              colon={false}
              labelAlign="right"
              label="Prezime"
              name="prezime"
              rules={[
                {
                  required: true,
                  message: 'Unesite prezime korisnika!',
                },
              ]}
            >
              <Input placeholder="Unesite prezime korisnika" />
            </Form.Item>

            <Form.Item
              initialValue={!isAddUser ? userState.currentUser.phoneNumber : ''}
              colon={false}
              labelAlign="right"
              label="Broj telefona"
              name="telefon"
              rules={[
                {
                  required: true,
                  message: 'Unesite broj telefona!',
                },
              ]}
            >
              <Input placeholder="Unesite broj telefona" />
            </Form.Item>

            <Form.Item
              initialValue={!isAddUser ? userState.currentUser.role : null}
              colon={false}
              labelAlign="right"
              label="Rola"
              name="rola"
              rules={[
                {
                  required: true,
                  message: 'Odaberite odgovarajuću rolu za korisnika!',
                },
              ]}
            >
              <Select
                placeholder="Odaberite odgovarajuću rolu za korisnika"
                onChange={handleChangeRola}
                options={roleOptions}
              />
            </Form.Item>

            <Form.Item
              initialValue={
                !isAddUser ? userState.currentUser.supplierId : null
              }
              colon={false}
              labelAlign="right"
              label="Dobavljač"
              name="dobavljač"
              rules={[
                {
                  required: true,
                  message: 'Odaberite odgovarajućeg dobavljača za korisnika!',
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                onChange={onChangeDobavljac}
                onSearch={onSearch}
                filterOption={filterOption}
                placeholder="Odaberite odgovarajućeg dobavljača za korisnika"
                options={userState.suppliersOptions.map(supplier => ({
                  value: supplier.key,
                  label: supplier.kompanija,
                }))}
              />
            </Form.Item>

            <Form.Item>
              <Button
                htmlType="submit"
                className="text-sm text-white bg-light-blue font-medium w-[132px] rounded-sm border-light-blue shadow-sm mt-6"
              >
                SPREMI
              </Button>
            </Form.Item>
          </Col>
          <Col span={8}>
            {showProvizija && (
              <Form.Item
                initialValue={
                  !isAddUser
                    ? userState?.currentUser?.hidebuttonProvision
                    : false
                }
                className="mb-7"
                name="provizija"
                valuePropName="checked"
                wrapperCol={{
                  offset: 7,
                  span: 16,
                }}
              >
                <Checkbox>Sakrij dugme provizije</Checkbox>
              </Form.Item>
            )}

            <Form.Item
              initialValue={
                !isAddUser ? userState.currentUser.notification : false
              }
              className="mb-5"
              name="notifikacija"
              valuePropName="checked"
              wrapperCol={{
                offset: 7,
                span: 16,
              }}
            >
              <Checkbox>Notifikacija za korisnika</Checkbox>
            </Form.Item>

            <Form.Item
              initialValue={`${
                !isAddUser
                  ? userState.currentUser.annotation !== null
                    ? userState.currentUser.annotation
                    : ''
                  : ''
              }`}
              name="napomena"
              wrapperCol={{
                offset: 7,
                span: 18,
              }}
            >
              <TextArea
                className={`h-64 ${!showProvizija && 'mt-1'}`}
                placeholder="Napomena:"
              />
            </Form.Item>

            {!isAddUser && userState.currentUser.isBlocked && (
              <Form.Item
                wrapperCol={{
                  offset: 7,
                  span: 16,
                }}
              >
                <div
                  style={{
                    color: 'red',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {isBlocked ? (
                    <>
                      <ExclamationCircleOutlined style={{ marginRight: 8 }} />
                      Korisnik je blokiran
                      <Popconfirm
                        title="Da li ste sigurni da želite odblokirati korisnika?"
                        onConfirm={() => {
                          setIsBlocked(false);
                        }}
                        okText={<span style={{ color: 'black' }}>Da</span>}
                        cancelText="Ne"
                      >
                        <Button type="link" style={{ marginLeft: 8 }}>
                          Odblokiraj
                        </Button>
                      </Popconfirm>
                    </>
                  ) : (
                    <div style={{ color: 'green', marginTop: 8 }}>
                      Promjene su napravljene. Molimo vas da spremite promjene.
                    </div>
                  )}
                </div>
              </Form.Item>
            )}
          </Col>
        </Row>
      </Form>
    </Space>
  );
};

export default RegisterEditForm;
